import { normalizeStrokeWidth } from './utils/normalizeStrokeWidth.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';

const PM2StudentIcon = ({
  color = "currentColor",
  strokeWidth = 1.5,
  ...svgProps
}) => {
  return /*#__PURE__*/jsx(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    ...svgProps,
    viewBox: "0 0 25 30",
    children: /*#__PURE__*/jsxs("g", {
      fill: "none",
      stroke: color,
      strokeWidth: normalizeStrokeWidth(strokeWidth, 30),
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: "10",
      transform: "translate(.5 .5)",
      children: [/*#__PURE__*/jsx("path", {
        d: "m12.501 12.002c3.059 0 5.538-2.463 5.538-5.501s-2.48-5.501-5.539-5.501c-3.057 0-5.536 2.463-5.536 5.501s2.48 5.501 5.537 5.501z"
      }), /*#__PURE__*/jsx("path", {
        d: "m7.884 16.272h8.913"
      }), /*#__PURE__*/jsx("path", {
        d: "m20.195 17.27a10.218 10.218 0 0 1 2.705 3.32 10.151 10.151 0 0 1 1.1 4.131v4.177m-23 0v-4.233a10.665 10.665 0 0 1 3.485-7.401",
        strokeMiterlimit: "10"
      }), /*#__PURE__*/jsx("path", {
        d: "m19.18 29c-2.154-3.703 1.17-10.327.905-11.763s-1.731-3.96-2.59-1.07c-.86 2.89-2.926 8.904-1.24 12.833m-10.621 0c2.106-3.703-1.144-10.327-.884-11.763s1.694-3.96 2.534-1.07 2.863 8.904 1.212 12.833",
        strokeLinejoin: "round"
      })]
    })
  });
};

export { PM2StudentIcon };
//# sourceMappingURL=student.js.map
